<div class="carousel-container">
  <div class="carousel-content">
    <div class="image-section">
      <div
        class="background-image"
        [style.background-image]="'url(' + blogs[activeIndex].imageLink + ')'"
      ></div>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <h2 [innerHTML]="getHighlightedTitle(blogs[activeIndex].title)"></h2>

        <!-- <p class="description">{{ blogs[activeIndex].content }}</p> -->
        <p class="description">
          <span
            *ngFor="
              let sentence of blogs[activeIndex].content.split('. ');
              let i = index
            "
          >
            {{ sentence
            }}{{
              i < blogs[activeIndex].content.split(". ").length - 1 ? ". " : ""
            }}
          </span>
        </p>

        <!-- <div class="points">
          <p *ngFor="let point of blogs[activeIndex].points">{{ point }}</p>
        </div> -->
      </div>

      <div class="cta">
        <a [href]="blogs[activeIndex].ctaLink" target="_blank"> Read Blog → </a>
      </div>

      <div class="progress-indicators">
        <div
          *ngFor="let blog of blogs; let i = index"
          class="progress-bar-container"
          [ngClass]="{ 'new-width': i === activeIndex }"
        >
          <div
            *ngIf="i === activeIndex"
            class="progress-bar-active"
            [style.width.%]="progress"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
